import type { HealthState } from '@central/api';
import type { StatusTone } from './tokens';

/** Staff wording of each health state. */
export const healthLabels: Record<HealthState, string> = {
  up: 'Healthy',
  degraded: 'Degraded',
  down: 'Down',
  unknown: 'Unknown',
  updating: 'Updating',
};

/** Maps an API health state to its chip tone; a planned update is informational. */
export function toneForHealth(state: HealthState): StatusTone {
  switch (state) {
    case 'up':
      return 'ok';
    case 'degraded':
      return 'warn';
    case 'down':
      return 'down';
    case 'updating':
      return 'blu';
    case 'unknown':
      return 'unk';
  }
}
